import { render, staticRenderFns } from "./FolderPlus.vue?vue&type=template&id=6805bc50&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FolderPlus.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FolderPlus.vue
// module id = 2409
// module chunks = 1